/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { DownloadItemFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { DownloadItemFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';

export const downloadItemProductDatasheetLink =
  'https://bilder.baur.de/v1/static/98346cc765dbb00274b00d7092795dc0';

export const downloadItemAssemblyLink =
  'https://bilder.baur.de/v1/static/59c724493635354154c229b427c6232d';

export const getDownloadItemDataMock = (type: DownloadItemFragmentFragment['type']) => {
  switch (type) {
    case 'ASSEMBLY_INSTRUCTIONS': {
      return {
        link: downloadItemAssemblyLink,
        type,
      };
    }
    default: {
      return {
        link: downloadItemProductDatasheetLink,
        type,
      };
    }
  }
};

export const downloadItemDataMock: DownloadItemFragmentFragment =
  getDownloadItemDataMock('ASSEMBLY_INSTRUCTIONS');

export function getDownloadItemFragmentedData(data?: DownloadItemFragmentFragment) {
  return makeFragmentData(data || downloadItemDataMock, DownloadItemFragmentFragmentDoc);
}
